import { Rect } from './Rect';
import { Post } from './Post';
import { EmptyRect } from './EmptyRect';
declare const THREE: any;

export class DoublePost extends Post {
  private picture = new THREE.ImageLoader().load('assets/images/scene-plan/c.png');

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));

  public modifiedAtStep3: boolean = false;

  constructor(picture?) {
    super();
    if (picture) {
      this.picture = picture;
    }
    const size = 10;
    // const texture = DoublePost.dcTexture.clone();
    const top = new EmptyRect(size);
    const bottom = new EmptyRect(size);

    top.position.set(-size / 2, 0, -size / 2);
    bottom.position.set(size / 2, 0, size / 2);

    const geometry = new THREE.PlaneBufferGeometry(1, 1).applyMatrix(DoublePost.rotationTransform);
    const material = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, transparent: true });
    let meshTop = new THREE.Mesh(geometry, material);
    let meshBottom = new THREE.Mesh(geometry, material);

    let canvas = document.createElement('canvas');

    let ctx = canvas.getContext('2d');

    meshTop.scale.set((10 / this.picture.height) * this.picture.width, 1, 8);
    meshBottom.scale.set((10 / this.picture.height) * this.picture.width, 1, 8);

    canvas.width = (10 / this.picture.height) * this.picture.width * 10;
    canvas.height = 8 * 10;

    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.drawImage(this.picture, 0, -canvas.height / 10, canvas.width, canvas.height * 1.2);

    if (!meshTop.material.map) {
      meshTop.material.map = new THREE.Texture(canvas);
    }
    meshTop.material.map.image = canvas;

    meshTop.material.map.needsUpdate = true;
    meshTop.material.needsUpdate = true;

    meshTop.name = 'text';

    meshTop.position.set(-size / 2, 0, -size / 2);

    if (!meshBottom.material.map) {
      meshBottom.material.map = new THREE.Texture(canvas);
    }
    meshBottom.material.map.image = canvas;

    meshBottom.material.map.needsUpdate = true;
    meshBottom.material.needsUpdate = true;

    meshBottom.name = 'text';

    meshBottom.position.set(size / 2, 0, size / 2);

    this.add(top, bottom, meshTop, meshBottom);
  }

  getSize(): number {
    return 20;
  }

  duplicate() {
    const result = new DoublePost();
    result.modifiedAtStep3 = true;
    result.update();
    return result;
  }

  getInfo() {
    let pos = {
      x: this.position.x,
      y: this.position.y,
      z: this.position.z
    };
    let rot = {
      x: this.rotation.x,
      y: this.rotation.y,
      z: this.rotation.z
    }
    return {
      type: "DoublePost",
      position: pos,
      rotation: rot,
      scaleCor: this.scaleCor
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/DoublePost.ts